module.exports = "<mat-icon svgIcon=\"marietti-logo\"></mat-icon>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/helpers/mat-icon-marietti/mat-icon-marietti.component.html
// module id = ./src/app/helpers/mat-icon-marietti/mat-icon-marietti.component.html
// module chunks = main